import "./styles.css";
import { useTranslation } from "react-i18next";

export const InfoSection = ({
  image,
  title,
  heading,
  description,
  subSections,
}) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <div className="info-section" role="presentation">
      <p
        style={{
          display: "flex",
          justifyContent: "center",
          fontFamily: "Fellix-Light",
          fontSize: "21px",
          textAlign: "center",
          marginTop: "-30px",
        }}
      >
        {heading}
      </p>
      <img
        src={image}
        className="info-section-image"
        alt={title}
        aria-hidden="true"
      />
      <div className="center">
        <div>
          <div
            role="text"
            className="info-section-title"
            aria-label={
              lang === "tr"
                ? title.toLowerCase().replaceAll("qr", "küar")
                : title.toLowerCase().replaceAll("Martı", "marti")
            }
          >
            {title}
          </div>
          <div
            role="text"
            className="info-section-description"
            aria-label={
              lang === "tr"
                ? String(description ?? "")
                    .toLowerCase()
                    .replaceAll("qr", "küar")
                : String(description ?? "")
                    .toLowerCase()
                    .replaceAll("Martı", "marti")
            }
          >
            {description}
          </div>
          {subSections?.map((block, i) => (
            <div key={i} className="info-section-sub-section">
              {block.heading != null && (
                <div className="info-section-sub-section-heading">
                  {block.heading}
                </div>
              )}
              {block.description != null && (
                <div
                  role="text"
                  className="info-section-description"
                  aria-label={
                    lang === "tr"
                      ? String(block.description)
                          .toLowerCase()
                          .replaceAll("qr", "küar")
                      : String(block.description)
                          .toLowerCase()
                          .replaceAll("Martı", "marti")
                  }
                >
                  {block.description}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
